import { Component } from '@angular/core';

@Component({
  selector: 'app-find-art',
  templateUrl: './find-art.component.html'
})
export class FindArtComponent {}
